import { apiClient } from './client';

export type BillingStatus = 'PENDING' | 'PAID' | 'CREDITED' | 'FAILED' | 'CANCELED' | 'REFUNDED';

export interface SwipaPackage {
  id: string;
  name: string;
  swipaAmount: number;
  bonusSwipa: number;
  priceKopecks: number;
  currency: string;
  active: boolean;
  sort: number;
}

export interface BillingOrder {
  id: string;
  status: BillingStatus;
  provider: string;
  swipaAmount: number;
  amountKopecks: number;
  currency: string;
  createdAt: string;
  creditedAt: string | null;
  pkg?: { id: string; name: string } | null;
}

export interface CursorPage<T> {
  data: T[];
  nextCursor: string | null;
  hasMore: boolean;
}

export const billingApi = {
  async listPackages(): Promise<{ packages: SwipaPackage[]; providers: string[] }> {
    const { data } = await apiClient.get('/api/billing/packages');
    return data;
  },

  async checkout(packageId: string, provider?: string): Promise<{ orderId: string; redirectUrl: string; provider: string }> {
    const { data } = await apiClient.post('/api/billing/checkout', { packageId, ...(provider ? { provider } : {}) });
    return data;
  },

  async getOrder(orderId: string): Promise<BillingOrder> {
    const { data } = await apiClient.get(`/api/billing/orders/${orderId}`);
    return data;
  },

  async listOrders(cursor?: string): Promise<CursorPage<BillingOrder>> {
    const { data } = await apiClient.get('/api/billing/orders', { params: cursor ? { cursor } : {} });
    return data;
  },
};

/** Копейки → "99 ₽" / "1 234,50 ₽". */
export function formatPrice(kopecks: number, currency = 'RUB'): string {
  const rub = kopecks / 100;
  const symbol = currency === 'RUB' ? '₽' : currency;
  const str = Number.isInteger(rub)
    ? rub.toLocaleString('ru-RU')
    : rub.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${str} ${symbol}`;
}
